<template>
  <ion-page class="listening-train-page" :class="theme">
    <ion-content>
      <div class="ion-content">
        <div class="header">
          <div class="left" @click="back('back')">
            <img class="icon-back" :src="imageMap.back" alt="" />
            <span>返回</span>
          </div>
          <div class="right">
            <ThemeTag class="img-box" />
            <SwitchFontSize />
            <Volume class="img-box" />
            <Accent class="img-box" />
            <Speed class="img-box" />
            <div
              v-if="step !== 1"
              class="toggle-box"
              :class="{ active: showTranslate }"
              @click="toggleTranslate"
            >
              <div class="point"></div>
              <span class="text">译</span>
            </div>
          </div>
        </div>
        <div class="topic-box">
          <div class="topic-box_title">
            <img :src="imageMap.title_icon" alt="" />
            <span>{{ summaryName }}</span>
          </div>
          <p>{{ linkTitle }}</p>
        </div>
        <div class="main-content">
          <div class="inner-box">
            <div class="components-box">
              <!-- 测 -->
              <TestChoiceQuestions
                v-if="step === 1"
                ref="TestChoiceQuestionsRef"
                :linkContent="linkContent"
              />
              <!-- 听 -->
              <Listen
                v-if="step === 2"
                ref="ListenRef"
                :link-content="linkContent"
              />
              <!-- 说 -->
              <Speak
                v-if="step === 3"
                ref="SpeakRef"
                :link-content="linkContent"
              />
              <!-- 记 -->
              <Remember v-if="step === 4" :link-content="linkContent" />
            </div>
            <Step
              :step="step"
              :step-list="stepList"
              @prevStep="changePrevStep"
              @nextStep="changeNextStep"
              @endStudy="handleEndStudy"
              @toStep="handleStep"
            />
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { IonPage, IonContent, modalController, toastController } from "@ionic/vue";
import { onMounted, ref, defineProps, computed } from "vue";
import http from "@/js/http";
import store from "@/js/store";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import ThemeTag from "./components/ThemeTag/ThemeTag.vue";
import Volume from "./components/Volume.vue";
import Accent from "./components/Accent.vue";
import Step from "./components/Step.vue";
import Speed from "./components/Speed.vue";
import TestChoiceQuestions from "./Test-ChoiceQuestions.vue";
import Listen from "./Listen.vue";
import Speak from "./Speak.vue";
import Remember from "./Remember.vue";
import FinishStudyDialog from "./components/FinishStudyDialog.vue";
import SwitchFontSize from "./components/SwitchFontSize.vue";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";

const listenStore = useListenConfigStore();

const imageMap = computed(() => imageConfig[theme.value]);

const theme = computed(() => listenStore.theme);

const props = defineProps([
  "topicType",
  "listenId",
  "linkType",
  "courseId",
  "studentId",
  "summaryName",
]);

const linkContent = ref(); //环节内容详情

const linkTitle = ref(""); //环节标题

const showTranslate = computed(() => listenStore.showTranslate); //全局翻译按钮显示状态

const stepList = ref([]); //环节列表

const step = ref(1); //环节步骤

const toggleTranslate = () => {
  listenStore.setShowTranslate(!showTranslate.value);
};

const back = () => {
  modalController.dismiss("back");
};

//下一环节
const TestChoiceQuestionsRef = ref();
const changeNextStep = async () => {
  step.value = step.value + 1;
  getListenChapterDetail();
};

//上一环节
const changePrevStep = () => {
  step.value = step.value - 1;
  getListenChapterDetail();

};

//点击环节名称跳转（仅限跳转环节为已完成状态）
const handleStep = (val) => {
  step.value = Number(val);
  getListenChapterDetail();
};

//结束学习的回调
const handleEndStudy = async () => {
  modalController.dismiss('back');
};


//获取环节类型列表
const getEnvironmentList = async () => {
  try {
    const { data } = await http.get("/listen/listenchapter/getEnvironmentList");
    if (data.code === 200) {
      stepList.value = data.data;
      getListenChapterUserComplete();
    }
  } catch (err) {
    console.error(err);
  }
};

//获取环节页面详情内容
const getListenChapterDetail = async () => {
  try {
    const { data } = await http.post("/listen/listenchapter/getListenChapterDetail", {
      listenId: props.listenId,
      aptmId: store.getAppointment().aptmId,
      topicType: props.topicType, //题型
      linkType: step.value, //环节类型
      studentId: props.studentId,
      courseId: props.courseId,
    });
    if (data.code === 200) {
      const result = JSON.parse(data.data);
      linkContent.value = JSON.parse(result.linkContent);
      linkTitle.value = result.stageDescription;
    }
  } catch (err) {
    console.error(err);
  }
};

//手动保存进度
const ListenRef = ref();
const SpeakRef = ref();

//获取环节完成情况
const stepFinished = ref(null);
const getListenChapterUserComplete = async () => {
  try {
    const { data } = await http.post("/listen/listenchapter/getListenChapterUserComplete", {
      listenId: props.listenId,
      courseId: props.courseId,
      studentId: props.studentId,
    });
    if (data.code === 200) {
      stepFinished.value = data.data;
      for (let i = 0; i < stepFinished.value; i++) {
        stepList.value[i].finished = true;
      }
    }
  } catch (e) {
    console.error(e);
  }
};

onMounted(async () => {
  step.value = props.linkType;
  await getEnvironmentList();
  await getListenChapterDetail();
});
</script>

<style lang="less" scoped>
@import "components/ThemeTag/listenTheme";
.listening-train-page {
  background-color: var(--page-background-color);
  .ion-content {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .header {
    font-size: 1.01rem;
    position: relative;
    height: 2.8rem;
    color: var(--page-title-color);
    padding: 0 0.95rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 9;
    background-color: var(--page-background-color);
    .icon-back {
      width: 0.38rem;
      height: 0.89rem;
      margin-right: 0.45rem;
      vertical-align: baseline;
    }
    .right {
      display: flex;
      align-items: center;
      gap: 0.95rem;
      img,
      .img-box {
        width: 1.28rem;
        height: 1.28rem;
        position: relative;
      }
      .switch-font-box {
        margin-right: 0;
      }
      .toggle-box {
        width: 2.2rem;
        height: 1.21rem;
        background-color: var(--toggle-bg-color);
        border-radius: 0.6rem;
        position: relative;
        display: flex;
        justify-content: flex-end;
        padding: 0 0.2rem;
        font-size: 0.67rem;
        .point {
          width: 0.95rem;
          height: 0.95rem;
          border-radius: 50%;
          background-color: white;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          transition: all linear 1s;
          left: 0.15rem;
        }
        .text {
          position: absolute;
          height: 1.21rem;
          line-height: 1.21rem;
          right: 0.25rem;
          transition: all linear 1s;
          color: var(--button-text-color);
        }
        &.active {
          text-align: left;
          background-color: var(--toggle-active-bg-color);
          .point {
            left: inherit;
            right: 0.15rem;
            transition: all linear 1s;
          }
          .text {
            left: 0.25rem;
            transition: all linear 1s;
          }
        }
      }
    }
  }
  .topic-box {
    padding: 0 0.95rem;
    color: var(--page-sub-title-color);
    &_title {
      font-weight: 500;
      font-size: 1rem;
      gap: 0.38rem;
      display: flex;
      justify-content: start;
      align-items: center;
      img {
        width: 1.15rem;
        height: 1.15rem;
      }
    }
    p {
      font-size: 0.89rem;
      color: var(--text-sub-title-color);
      line-height: 1.21rem;
      font-weight: 400;
      margin: 0.38rem 0 0 0;
    }
  }
  .main-content {
    padding: 0.64rem;
    flex: 1;
    height: 0;
    .inner-box {
      background-color: var(--page-inner-bg);
      border-radius: 1rem;
      width: 100%;
      height: 100%;
      position: relative;
      padding: 0.95rem 0.95rem 0 0.95rem;
      .components-box {
        width: 100%;
        overflow-y: auto;
        height: calc(100% - 3rem);
        position: relative;
      }
    }
  }
}
</style>
<style>
.center_modal_controller_class_finish_study {
  --height: 19.5rem;
  --max-height: 19.5rem;
  --min-height: 19.5rem;
  --max-width: 19rem;
  --min-width: 19rem;
  --width: 19rem;
  --overflow: visible;
  --backdrop-opacity: 0.32 !important;
  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
}
.center_modal_controller_class_message {
  --height: 11rem;
  --max-height: 13rem;
  --min-height: 11rem;
  --max-width: 16rem;
  --min-width: 16rem;
  --width: 16rem;
  --overflow: visible;
  --backdrop-opacity: 0.32 !important;
  &::part(content) {
    width: 100%;
    height: 100%;
    border-radius: 1rem;
  }
}
</style>
